export default {
  ELEC_STATUS: {
    qualified_0: 0, // 合格
    waittingForUploadMaterial_1: 1, // 待上传资料
    waittingForVerified_2: 2, // 待预审
    unqualified_3: 3, // 不合格
  },
  PHOTO_STATUS: {
    verifyPassed_0: 0, // 合格
    waittingForUploadMaterial_1: 1, // 待上传资料
    waittingForVerified_2: 2, // 待预审
    verifyNotPassed_3: 3, // 资料不完善
  },
  TYPE: {
    elec_0: 0, // 电子
    papery_1: 1, // 纸质
    carry_2: 2, // 携带
  },
  PAPERY_STATUS: {
    qualified_0: 0, // 合格
    waittingForMailing_1: 1, // 待邮寄
    waittingForReceive_2: 2, // 待签收
    waittingForVerified_3: 3, // 待预审
    unqualified_4: 4, // 不合格
  },
  APPLY_STATUS: {
    verifyPassed_0: 0, // 合格
    waittingForWrite_1: 1, // 待填写
    waittingForVerified_2: 2, // 待预审
    verifyNotPassed_3: 3, // 不合格
  },
  EXPRESS_STATUS: {
    waittingForSign: 0, // 待签收
    signed: 1, // 已签收
  },
  PATTERN: {
    defaul_0: 0, // 默认
    idCardOCR_1: 1, // 身份证OCR
    passortOCR_2: 2, // 护照OCR
    marriageCertificate_3: 3, // 婚姻证明
    table_4: 4, // 婚姻证明
  },
  STYLE: {
    singlePage_0: 0, // 单页
    multiPage_1: 1, // 多页
  },
  ID_CARD: {
    front: 1, // 正面
    back: 2, // 背面
  },
  SPECIAL_CODE: {
    less16_1: 1, // 未满16周岁，尚未办理身份证
    idCardLost_2: 2, // 身份证丢失
    unmarried_3: 3, // 未婚
    widowed_4: 4, // 丧偶
    materialRequired_5: 5, // 需补充资料
    temporarilyNotUpload_6: 6, // 暂不补充资料
  },
  MARITAL_STATUS: {
    unknown_0: 0, // "未知"
    unmarried_1: 1, // "未婚"
    married_2: 2, // "已婚"
    divorced_3: 3, // 离婚
    widowed_4: 4, // "丧偶"
  },
  RELATION_TYPE_ID: {
    none_0: 0, // 无
    on_job_1: 1, // 在职证明
  },
};



// WEBPACK FOOTER //
// ./src/constants/material-constants.js